'use client';

import React from 'react';
import Link from 'next/link';
import * as Styled from './styled';
import { UserAvatar } from '@/components/Avatar';
import emojify from '@/lib/emojify';
import { toTimeAgo } from '@/lib/dateTime';

import { IRepository, IEntityUser, ICommit } from '@/types';

export const CommitUser: React.FC<{
  commit: ICommit;
}> = ({ commit }) => {
  const user: IEntityUser = {
    id: commit.author,
    username: commit.author,
    name: commit.author,
    email: commit.email,
    image: undefined,
  };
  return (
    <Styled.TightRow>
      <UserAvatar user={user} size={16} />
      <b>{commit.author}</b>
    </Styled.TightRow>
  );
};

const CommitDetails: React.FC<{
  commit: ICommit;
  repository?: IRepository;
}> = ({ commit, repository }) => {
  return (
    <Styled.CommitDetails>
      <CommitUser commit={commit} />
      <div className="message" title={emojify(commit.message)}>
        {emojify(commit.message)}
      </div>
    </Styled.CommitDetails>
  );
};

export const CommitDetailsWithTime: React.FC<{
  commit: ICommit;
  repository: IRepository;
}> = ({ repository, commit }) => {
  const commitPath = `/${repository.namespace}/${repository.name}/commit/${commit.id}`;
  return (
    <Styled.CommitIndicator>
      <CommitDetails commit={commit} />
      <Styled.CommitHistory>
        <Styled.TightRow className="lastCommit">
          <Link href={commitPath} className="hover-link">
            <div className="commitRef">{commit.id}</div>
          </Link>
          <div>·</div>
          <div>{toTimeAgo(commit.timestamp)}</div>
        </Styled.TightRow>
      </Styled.CommitHistory>
    </Styled.CommitIndicator>
  );
};

export default CommitDetails;
